/**
 * Copyright 2025 John Huikku Alienrobot LLC
 * www.ALIENROBOT.com
 */

/**
 * LLM Brand Logos as SVG components
 * Simple, recognizable logos for Gemini, Claude, and Grok
 */

interface LogoProps {
  className?: string
}

export function GeminiLogo({ className = "w-4 h-4" }: LogoProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {/* Google Gemini sparkle/star icon */}
      <path
        d="M12 2L14.5 9.5L22 12L14.5 14.5L12 22L9.5 14.5L2 12L9.5 9.5L12 2Z"
        fill="currentColor"
        opacity="0.9"
      />
      <circle cx="12" cy="12" r="2" fill="currentColor" />
    </svg>
  )
}

export function ClaudeLogo({ className = "w-4 h-4" }: LogoProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {/* Anthropic Claude - stylized "A" or wave pattern */}
      <path
        d="M4 20L8 8L12 16L16 4L20 12"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <circle cx="12" cy="16" r="1.5" fill="currentColor" />
    </svg>
  )
}

export function GrokLogo({ className = "w-4 h-4" }: LogoProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {/* xAI Grok - X shape with modern styling */}
      <path
        d="M4 4L20 20M20 4L4 20"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
      />
      <circle cx="12" cy="12" r="3" fill="currentColor" opacity="0.3" />
    </svg>
  )
}

export function JudgeLogo({ className = "w-4 h-4" }: LogoProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {/* Balance scale for judge */}
      <path
        d="M12 3V21M6 9L12 3L18 9M6 9H2L4 15H8L6 9ZM18 9H22L20 15H16L18 9Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <line x1="4" y1="21" x2="20" y2="21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </svg>
  )
}

